export const env = {
  baseUrl: "https://api-dev.rxgames.com",
  // baseUrl: "https://ecd4-67-21-32-199.ngrok-free.app/dev",
  // baseUrl: "https://nd4n9prz61.execute-api.us-east-1.amazonaws.com/dev", // No trailing slash
  stage: "dev",
  VITE_CLERK_PUBLISHABLE_KEY:"pk_test_a2V5LXBhbmRhLTU5LmNsZXJrLmFjY291bnRzLmRldiQ"
};
